module.exports = __webpack_public_path__ + "static/img/img23.06e535d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/help/img23.png
// module id = t4LB
// module chunks = 1